exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.projectDetailsText[data-v-720545d0]{padding-right:6px !important;font-size:1.1rem !important;color:grey !important;text-align:left !important\n}\n", ""]);

// exports
